import styled, { css } from "styled-components";

// styles
import colors from "core/colors";

// styled-components
export const FooterStyled = styled.div`
    background-color: ${colors.primary.whisker};
`;
